<div class="loader_wrap" [ngClass]="{alert: isAlertDialog}">
    <div class="loader"></div>
</div>